import {NavSlider} from "./nav-slider.component";

export class NavSliderDomInjector {
    public static SCROLL_CORRECTION = 11;
    private cachedListItems: HTMLLIElement[] | null = null;

    constructor(
        private document: Document,
        private window: Window,
        private hostElement: HTMLElement,
        private navSlider: NavSlider
    ) {
        const debouncedToggle = this.debounce(() => {
            this.cachedListItems = null;
            this.toggleClippingClass();
        }, 100);

        this.window.addEventListener('DOMContentLoaded', debouncedToggle);
        this.window.addEventListener('orientationchange', debouncedToggle);
        this.window.addEventListener('resize', debouncedToggle);
        this.window.addEventListener('scroll', debouncedToggle);
        this.hostElement.addEventListener('scroll', debouncedToggle);
    }

    toggleClippingClass(): void {
        let clippingLeft = false;
        let clippingRight = false;

        if (this.getLeftClippingElement() !== null) {
            clippingLeft = true;
        }

        if (this.getRightClippingElement() !== null) {
            clippingRight = true;
        }

        this.navSlider.config.toggleClippingClass(clippingLeft, clippingRight);
    }

    getLeftClippingElement(): HTMLLIElement {
        const children = this.getListItems();
        let child: HTMLLIElement = null;
        for (let i = children.length - 1; i >= 0; i--) {
            child = children[i];
            if (child.offsetLeft < this.hostElement.scrollLeft) {
                return child;
            }
        }
        return null;
    }

    getRightClippingElement(): HTMLLIElement {
        const children = this.getListItems();
        let child: HTMLLIElement = null;
        for (let i = 0; i < children.length; i++) {
            child = children[i];
            if (child.offsetLeft + child.offsetWidth > this.hostElement.offsetWidth + this.hostElement.scrollLeft + NavSliderDomInjector.SCROLL_CORRECTION) {
                return child;
            }
        }
        return null;
    }

    slideLeft(): void {
        const clippingElement = this.getLeftClippingElement();
        if (clippingElement === null) {
            return;
        }
        const minScroll = 0;
        const scroll = clippingElement.offsetLeft + clippingElement.offsetWidth - this.hostElement.offsetWidth;
        this.hostElement.scrollLeft = minScroll > scroll ? minScroll : scroll;
    }

    slideRight(): void {
        const clippingElement = this.getRightClippingElement();
        if (clippingElement === null) {
            return;
        }
        const maxScroll = this.hostElement.scrollWidth - this.hostElement.offsetWidth;
        const scroll = clippingElement.offsetLeft;
        this.hostElement.scrollLeft = maxScroll < scroll ? maxScroll : scroll;
    }

    private debounce(fn: () => void, wait: number): () => void {
        let timeout: NodeJS.Timeout | null = null;
        return () => {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(fn, wait);
        };
    }

    private getListItems(): HTMLLIElement[] {
        if (this.cachedListItems !== null) {
            return this.cachedListItems;
        }

        const items = this.hostElement.querySelectorAll(this.navSlider.config.listItemSelector);
        if (items.length === 0) {
            return [];
        }

        const liItems = Array.from(items) as HTMLLIElement[];
        this.cachedListItems = liItems;

        return liItems;
    }
}